/*
  FGF — the pack image on the colour cards (home page product scroll + mega menu Popular cards). Todo 520429765, 21 Sep.

  snippets/fgf-cutout-image shows a product's MAIN image on its card whenever that image is a PNG/WebP, so a new
  transparent pack shot reaches the home page by itself. Uploads keep their empty margin (the 1200x1200 PNGs uploaded
  on 21 Sep carry ~20% of transparent space round the pack), which would make that pack look smaller than its
  neighbours. So this script measures the pack — every pixel that isn't transparent — and swaps in Shopify's own crop
  of exactly that area (…&crop=region&crop_left=…): the card then shows it exactly like every other tight cut-out.

  A file with no transparent pixels is not a cut-out: the card switches to the stored cut-out (custom.card_image) if
  the product has one, otherwise keeps the image as uploaded. Anything unexpected (unreadable image, failed crop
  URL) falls back to showing the image as uploaded — the card never stays empty.

  The image is kept invisible until it is final (html.fgf-cut-ready + the snippet's CSS), so the uncropped version
  never flashes. Measurements are remembered per image URL; the ?v= in the URL changes whenever the file does.
*/
(function () {
  'use strict';
  if (window.fgfCutout) return;

  var SEL = 'img[data-fgf-cut]';
  var STORE = 'fgf-cut:v1:';
  var ALPHA = 8;          // a pixel with more alpha than this is part of the pack (the stored cut-outs' threshold)
  var MIN_CLEAR = 0.01;   // fewer transparent pixels than this (1%) = not a cut-out
  var MAX = 600;          // measuring resolution, longest side. Measuring a downscaled copy errs OUTWARD (resampling
                          // spreads alpha), so the crop can't cut into the pack: on the 21 Sep uploads it lands 0-3px
                          // outside the full-resolution edges at every candidate size, never inside them

  function state(img) { return img.getAttribute('data-fgf-cut'); }
  function finish(img) { img.setAttribute('data-fgf-cut', 'done'); }

  function cacheKey(img) {
    try {
      var u = new URL(img.getAttribute('src'), location.href);
      return STORE + u.pathname + '?v=' + (u.searchParams.get('v') || '');
    } catch (e) { return null; }
  }
  function recall(k) { try { return k ? JSON.parse(localStorage.getItem(k) || 'null') : null; } catch (e) { return null; } }
  function remember(k, v) { try { if (k) localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode etc. */ } }

  function srcsetWidths(img) {
    var out = [];
    (img.getAttribute('srcset') || '').split(',').forEach(function (part) {
      var m = part.trim().match(/\s(\d+)w$/);
      if (m) out.push(+m[1]);
    });
    return out;
  }

  function cropUrl(src, r, w) {
    var u = new URL(src, location.href);
    u.searchParams.delete('height');
    u.searchParams.set('width', w);
    u.searchParams.set('crop', 'region');
    u.searchParams.set('crop_left', r.l);
    u.searchParams.set('crop_top', r.t);
    u.searchParams.set('crop_width', r.w);
    u.searchParams.set('crop_height', r.h);
    return u.href;
  }

  // true when >= 90% of the 1px border is within 16 levels of the border's average colour
  function flatBorder(d, cw, ch) {
    var px = [], i, n, sr = 0, sg = 0, sb = 0, near = 0;
    for (i = 0; i < cw; i++) { px.push(i, (ch - 1) * cw + i); }
    for (i = 1; i < ch - 1; i++) { px.push(i * cw, i * cw + cw - 1); }
    for (n = 0; n < px.length; n++) { i = px[n] * 4; sr += d[i]; sg += d[i + 1]; sb += d[i + 2]; }
    sr /= px.length; sg /= px.length; sb /= px.length;
    for (n = 0; n < px.length; n++) {
      i = px[n] * 4;
      if (Math.abs(d[i] - sr) <= 16 && Math.abs(d[i + 1] - sg) <= 16 && Math.abs(d[i + 2] - sb) <= 16) near++;
    }
    return near / px.length >= 0.9;
  }

  // the pack's bounding box in the ORIGINAL image's pixels, or 'opaque' (a photo on a background) / 'tight'
  function measure(img) {
    var nw = img.naturalWidth, nh = img.naturalHeight;
    var W = +img.getAttribute('data-fgf-cut-w') || nw, H = +img.getAttribute('data-fgf-cut-h') || nh;
    var s = Math.min(1, MAX / Math.max(nw, nh));
    var cw = Math.max(1, Math.round(nw * s)), ch = Math.max(1, Math.round(nh * s));
    var c = document.createElement('canvas');
    c.width = cw; c.height = ch;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, cw, ch);
    var d = ctx.getImageData(0, 0, cw, ch).data;          // throws for an unreadable image -> shown as uploaded
    var x0 = cw, y0 = ch, x1 = -1, y1 = -1, clear = 0;
    for (var y = 0; y < ch; y++) {
      for (var x = 0; x < cw; x++) {
        if (d[(y * cw + x) * 4 + 3] > ALPHA) {
          if (x < x0) x0 = x;
          if (x > x1) x1 = x;
          if (y < y0) y0 = y;
          if (y > y1) y1 = y;
        } else {
          clear++;
        }
      }
    }
    if (x1 < 0) return 'opaque';
    if (clear / (cw * ch) < MIN_CLEAR) {
      // no transparency: a photo on a flat background (white studio sweep, grey…) has a border of one colour;
      // a pack that fills its frame edge to edge does not — that one is shown as uploaded
      return flatBorder(d, cw, ch) ? 'opaque' : 'tight';
    }
    var l = Math.floor((x0 / cw) * W);
    var t = Math.floor((y0 / ch) * H);
    var r = Math.min(W, Math.ceil(((x1 + 1) / cw) * W));
    var b = Math.min(H, Math.ceil(((y1 + 1) / ch) * H));
    if (r - l >= W * 0.99 && b - t >= H * 0.99) return 'tight';   // already cropped to the pack
    return { l: l, t: t, w: r - l, h: b - t };
  }

  function applyCrop(img, r) {
    var src = img.getAttribute('src');
    var ws = srcsetWidths(img).map(function (w) { return Math.min(w, r.w); });
    if (!ws.length) ws = [r.w];
    ws = ws.filter(function (w, i) { return ws.indexOf(w) === i; });
    img.setAttribute('data-fgf-cut-orig', JSON.stringify([src, img.getAttribute('srcset') || '']));
    img.setAttribute('data-fgf-cut-want', 'crop=region');
    img.setAttribute('data-fgf-cut', 'cropping');
    img.srcset = ws.map(function (w) { return cropUrl(src, r, w) + ' ' + w + 'w'; }).join(', ');
    img.src = cropUrl(src, r, Math.max.apply(null, ws));
  }

  function useStored(img) {
    var fb = img.getAttribute('data-fgf-cut-fallback');
    if (!fb) { finish(img); return; }
    var last = fb.split(',').pop().trim().split(/\s+/)[0];
    img.setAttribute('data-fgf-cut-want', new URL(last, location.href).pathname);
    img.setAttribute('data-fgf-cut', 'fallback');
    img.srcset = fb;
    img.src = last;
  }

  function decide(img, verdict) {
    if (verdict === 'opaque') useStored(img);
    else if (verdict === 'tight' || !verdict) finish(img);
    else applyCrop(img, verdict);
  }

  function onLoad(img) {
    var st = state(img);
    if (st === 'done') return;
    if (st === 'cropping' || st === 'fallback') {
      // finish only on the load of the file asked for, not a late event from the one it replaced
      if ((img.currentSrc || img.src).indexOf(img.getAttribute('data-fgf-cut-want')) !== -1) finish(img);
      return;
    }
    var k = cacheKey(img), verdict = recall(k);
    if (!verdict) {
      try { verdict = measure(img); } catch (e) { finish(img); return; }
      remember(k, verdict);
    }
    decide(img, verdict);
  }

  function onError(img) {
    if (state(img) === 'cropping') {            // the crop URL failed: back to the image as uploaded
      var o = [];
      try { o = JSON.parse(img.getAttribute('data-fgf-cut-orig') || '[]'); } catch (e) { /* keep [] */ }
      finish(img);
      if (o[0]) { img.srcset = o[1]; img.src = o[0]; }
    } else {
      finish(img);
    }
  }

  window.fgfCutout = { measure: measure };
  document.addEventListener('load', function (e) { var t = e.target; if (t && t.matches && t.matches(SEL)) onLoad(t); }, true);
  document.addEventListener('error', function (e) { var t = e.target; if (t && t.matches && t.matches(SEL)) onError(t); }, true);
  document.documentElement.classList.add('fgf-cut-ready');

  // images that already loaded before this script ran; and, for images still waiting (lazy), a crop measured on an
  // earlier visit is applied straight away so the uncropped file is never downloaded again
  Array.prototype.forEach.call(document.querySelectorAll(SEL), function (img) {
    if (state(img) !== 'main') return;
    if (img.complete) {
      if (img.naturalWidth) onLoad(img); else finish(img);
      return;
    }
    var verdict = recall(cacheKey(img));
    if (verdict) decide(img, verdict);
  });
})();
